<template>
    <b-container>
        <b-alert :show="showDismissibleAlert" :variant="variant">{{alertText}}</b-alert>
        <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
        <b-row class="justify-content-md-center">
            <b-col md="6" sm="12" class="mt-2">
                <p style="font-size: 17px;color:#2284ab;">Receipt</p>
                <p></p>
                <div id="printMe" style="padding: 10px;  
                        border: 2px solid #ddd;
                        border-radius: 15px; text-align:center;display: flex;">
                    <table width="100%" border="1" style="border-collapse: collapse; border: 1px solid #ddd;">
                        <tr style="height:30px; text-align:Left; font-size: 0.875rem;" >
                            <td style="border: 1px solid #ddd" width="50%">
                            Name
                            </td>
                            <td style="border: 1px solid #ddd" >{{form.UserName}}</td>
                        </tr>

                        <tr style="height:30px; text-align:Left; font-size: 0.875rem;">
                            <td style="border: 1px solid #ddd"  width="50%">
                            Application ID
                            </td>
                            <td style="border: 1px solid #ddd" >{{applicationId}} </td>
                            
                        </tr>

                        <tr style="height:30px; text-align:Left; font-size: 0.875rem;">
                            <td style="border: 1px solid #ddd" width="50%">
                            Transaction ID
                            </td>
                            <td style="border: 1px solid #ddd" >{{form.UserPaymentID}} </td>
                        </tr>
                        <tr style="height:30px; text-align:Left; font-size: 0.875rem;">
                            <td style="border: 1px solid #ddd" width="50%">
                            Transaction Referance Number
                            </td>
                            <td style="border: 1px solid #ddd" >{{form.TransacstionRefNum}} </td>
                            
                        </tr>
                        <tr style="height:30px; text-align:Left; font-size: 0.875rem;">
                            <td style="border: 1px solid #ddd" width="50%">
                                Amount
                            </td>
                            <td style="border: 1px solid #ddd" >&#8377;{{form.TransactionAmount}}</td>
                        </tr>
                        <tr style="height:30px; text-align:Left; font-size: 0.875rem;">
                            <td style="border: 1px solid #ddd" width="50%">
                                Payment Towards
                            </td>
                            <td style="border: 1px solid #ddd" >{{form.TransactionType}} </td>
                        </tr>
                        <tr style="height:30px; text-align:Left; font-size: 0.875rem;">
                            <td style="border: 1px solid #ddd" width="50%">Date</td>
                            <td style="border: 1px solid #ddd" >{{form.TransactionDate}} </td>
                        </tr>
                        <tr style="height:30px; text-align:center; font-size: 0.875rem;" v-if="form.TransactionStatus =='Credit'">
                            <td style="border: 1px solid #ddd" colspan="2">Payment Successful!</td>
                        </tr>  
                        <tr style="height:30px; text-align:center; font-size: 1rem;" v-if="form.TransactionStatus !='Credit'">
                            <td style="border: 1px solid #ddd color:red" colspan="2">ERROR IN PROCESSING YOUR REQUEST.</td>
                        </tr>                     
                </table>    
                </div>
                
                <b-btn variant="success" class="float-right mt-2" size="sm" v-print>Print Receipt</b-btn>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";

export default {
  props: ["paymentId"],
  components: { Spinner },
  watch: {
    paymentId: function(newVal, oldVal) {
      let payload = {
        UserID: userinfo.UserId,
        PaymentID: "",
        PaymentRequestID: newVal
      };
      let promise = apis.ReadPaymentStatusInsta(payload);
      promise
        .then(response => {
          if (response.status == 200) {
            this.form = response.body;
            this.isLoading = false;
            if (this.form.TransactionStatus == "Credit") {
              this.alertText = "Payment Successful";
            } else {
              this.alertText = this.form.ErrorMessage;
            }
            this.show = true;
          } else {
            this.alertText =
              "Unable to confirm the Payment Status as Server contact is lost";

            this.variant = "warning";
            this.showDismissibleAlert = true;
            this.isLoading = false;
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      //console.log("Prop changed: ", newVal, " | was: ", oldVal);
    }
  },
  data() {
    return {
      isLoading: true,
      showDismissibleAlert: true,
      variant: "info",
      alertText: "Please wait while we check the payment status.",
      form: {
        TransactionStatus: "",
        TransactionDate: "",
        TransactionAmount: 0,
        TransacstionRefNum: "",
        TransactionType: "",
        UserName: "",
        ErrorMessage: "",
        UserPaymentID: ""
      },
      applicantName: "--",
      transactionId: "--",
      applicationId: "--",
      transactionReferenceNumber: "--",
      Amount: 0.0,
      Service: "--",
      transactionDate: "--",
      pmtMessage: "--",
      pmtStatus: "Success",
      show: true
    };
  }
};
</script>

<style scoped>
.body-wrapper {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  -webkit-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
}

.body-title {
  padding: 15px 25px;
  background: #fcfcfc;
  border-bottom: solid 2px #aaa;
}

.body-content {
  padding: 25px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/PaymentReceipt.vue